module.exports = __webpack_public_path__ + "img/edit.7bb3eed7.svg";